import React from 'react';

import FormHelperText, { FormHelperTextClassKey } from '@material-ui/core/FormHelperText';

interface IHelperTextProps {
  visible: boolean;
  message?: string;
  classes?: Partial<Record<FormHelperTextClassKey, string>>;
}

export const HelperText = ({ visible, message, classes }: IHelperTextProps) => (
  <FormHelperText
    classes={{
      ...classes,
      root: `form-helper-text override ${classes ? classes.root || '' : ''}`
    }}
  >
    {visible && message}
  </FormHelperText>
);
